import { InputAdornment, IconButton, List, ListItem, ListItemText, Popover, TextField } from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import React, { useRef, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import filterClientsUseCase from 'tasks/services/filterClientsUseCase';
import { selectClient } from '../../actions';
import { getClientsData } from '../../clients/services/reducers';

const SearchClient = ({ clients, clientSelected, selectClient, props, handleTab, handleSelect }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [text, setText] = useState(props.value || "")
    const field = 'id'

    const refInput = useRef(null)

    const handleSelectClient = client => {
        setText(client[field])
        selectClient({ client })
        props.onChange(client[field])
        handleSelect()
    }

    const handleCleanClient = () => {
        setText('')
        selectClient({ client: { clean: true} })
        props.onChange('')
    }

    useEffect(() => {
        const clientSelectedOtherTask = !text && clientSelected.id
        const client = clients[text]

        if (clientSelectedOtherTask) {
            selectClient({ client: {} })
        } else if (client) {
            selectClient({ client })
        } else {
            setText(text)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        function handleClickOutside(event) {
            if (refInput.current && !refInput.current.contains(event.target)) {
                setAnchorEl(null)
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        refInput.current.addEventListener('keyup', event => {
            if (event.key === 'Tab') {
                setAnchorEl(null)
                handleTab()
            }
        })

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refInput]);

    const handleSetText = (event) => {
        const text = event.target.value
        setText(text)
        props.onChange(text)
    }

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget)
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const data = filterClientsUseCase({ clients: getClientsData(clients).sort((c1, c2) => c2.lastUpdated - c1.lastUpdated), textSearch: text, limit: 10 })
    const renderClient = client => `${client.name} - ${client.id}`

    const inputAdornment = () => clientSelected.id && (
        <InputAdornment position="start">
        <IconButton disabled={text === ""} onClick={handleCleanClient}>
            <ClearIcon />
        </IconButton>
        </InputAdornment> 
    )

    return (
        <div>
            <TextField
                inputRef={refInput}
                value={text}
                onFocus={handleClick}
                onBlur={handleClose}
                onChange={handleSetText}
                disabled={!!clientSelected.id}
                placeholder='DNI'
                InputProps={{
                    style: { fontSize: '13px' },
                    endAdornment: inputAdornment()
                }}
            />
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                disableAutoFocus={true}
            >
                <List>
                    {data.map(client =>
                        <ListItem key={client.id} button onClick={() => handleSelectClient(client)}>
                            <ListItemText primary={renderClient(client)} />
                        </ListItem>
                    )}
                    {data.length === 0 && 
                        <ListItem key='0'>
                            <ListItemText primary="Ningun cliente encontrado" />
                        </ListItem>
                    }
                </List>
            </Popover>
        </div>
    );
}

const mapDispatchToProps = dispatch => ({
    selectClient: payload => dispatch(selectClient(payload))
})

const mapStateToProps = state => ({
    clients: state.clients.data,
    clientSelected: state.tasks.clientSelected
})

export default connect(mapStateToProps, mapDispatchToProps)(SearchClient)